export function formatProductionTicket(orders) {
  let content = "";

  orders.forEach((order) => {
    // Tratamento de segurança para dados opcionais
    let dateSimple = "-";
    if (order.dateStr && typeof order.dateStr === "string") {
      dateSimple = order.dateStr.split(" ")[0];
    } else if (order.dateIn) {
      dateSimple = order.dateIn; // Fallback direto se vier do objeto flat
    }
    const orderNum = order.order?.number || "-";
    const sku = order.sku || "-";
    
    // Lote de Produção da Fábrica (Código legível digitado/nomeado, rejeita IDs de 15 caracteres)
    let rawBatch = order.loteCodigo || order.lote_codigo || order.loteName;
    if (!rawBatch && order.lote && !order.lote.match(/^[a-z0-9]{15}$/i)) {
      rawBatch = order.lote;
    }
    const productionBatch = (rawBatch && String(rawBatch).trim() !== "" && rawBatch !== "-") 
      ? String(rawBatch).trim() 
      : "AVULSO";

    // Lógica para pegar o nome do Cliente
    const customerName =
      order.customerName || order.order?.customer?.name || "ND";

    // Specs (com fallback para "-")
    const size = order.specs?.size || "-";
    const stone = order.specs?.stoneType || "-";
    const color = order.specs?.stoneColor || "-";
    const stoneBatch = order.specs?.stoneBatch || "-"; // Lote específico da Pedra (Insumo)
    const finish = order.specs?.finishing || "-";
    const engraving = order.specs?.engraving || "-";
    const type = order.specs?.jewelryType || "-";
    const material = order.specs?.material || "-";
    const category = order.specs?.category || "-";

    // Montagem do Layout (Otimizado para leitura rápida)
    content += "--------------------------\n";
    content += `LOTE FABRICA: ${productionBatch}\n`;
    content += `PEDIDO: ${orderNum}\n`;
    content += `DATA:   ${dateSimple}\n`;
    content += `CLIENTE: ${customerName}\n`;
    content += "--------------------------\n";

    // Bloco Principal (O que fabricar)
    content += `SKU:  ${sku}\n`;
    content += `ARO:  ${size}\n`;
    content += `METAL: ${material}\n`;
    content += "--------------------------\n";

    // Bloco da Pedra (Lote do Insumo da Pedra)
    content += `PEDRA: ${stone}\n`;
    content += `COR:   ${color}\n`;
    content += `LOTE PEDRA: ${stoneBatch}\n`; // <--- AQUI
    content += "--------------------------\n";

    // Bloco de Acabamento
    content += `ACAB.: ${finish}\n`;
    content += `GRAV.: ${engraving}\n`;
    content += `TIPO:  ${type} / ${category}\n`;

    content +=
      "-------------------------\n       SUBLISMITH\n-------------------------\n\n\n";
  });

  return content;
}
